import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    margin-bottom: 2.3rem;
    margin-top: 1.3rem;
    gap: 1rem;
    align-items: center;
    width: 80rem;
`

export const CustomTextField = styled(TextFieldMui)`
    width: 32rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`

export const CustomSelect = styled(SelectMui)`
    width: 28rem;    
    margin: 0 !important;
    height: 2.5rem !important;
`

export const CustomButton = styled(ButtonMui)`
    width: 16rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`

export const CustomButtonBadges = styled(ButtonMui)`
    width: 33rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`

export const CustomSelectWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 1.4rem;
  margin-bottom: 0;
  height: 2.5rem !important;
`
